import React from 'react';
import Header from '../components/layout/Header';
import Footer from '../components/layout/Footer';
import Hero from '../components/home/Hero';
import Mission from '../components/home/Mission';
import HowItWorks from '../components/home/HowItWorks';
import About from '../components/home/About';
import BoardCarousel from '../components/home/BoardCarousel';
import Comparison from '../components/home/Comparison';
import Press from '../components/home/Press';
import CTA from '../components/home/CTA';

const Home = () => {
  return (
    <div className="min-h-screen bg-[#0B1121]">
      <Header />
      <main>
        <Hero />
        <Mission />
        <HowItWorks />
        <About />
        <BoardCarousel />
        <Comparison />
        <Press />
        <CTA />
      </main>
      <Footer />
    </div>
  );
};

export default Home;
